import React, { useEffect, useRef } from "react";
import Validator from "util/form-validator";
import Field from "visual-components/util/inputs/field";

/**
 * X (formerly Twitter) Follow Component
 * Handles the configuration for X follow social action
 * @param {Object} props - Component props
 * @param {Object} props.bonus - Bonus item details
 * @param {number} props.bonus.id - Bonus item ID
 * @param {number} props.bonus.partnership_invite_id - Partnership invite ID
 * @param {Object} props.bonus.data - Bonus item data containing xHandle
 * @param {Object} props.bonusItems - All bonus items in the campaign
 * @param {Function} props.updateBonusDataAttr - Function to update bonus data attributes
 * @returns {import("react").ReactElement} - Rendered component
 */
export default function XFollow(props) {
  const {
    bonus: { data },
    updateBonusDataAttr,
  } = props;

  const fieldRef = useRef(null);

  useEffect(() => {
    // Trigger validation on mount if field has a value
    const field = fieldRef.current;
    if (field && field.validate && field.valueFromDataModel) {
      field.validate(field.valueFromDataModel());
    }
  }, []);

  return (
    <Field
      ref={fieldRef}
      label="X Handle"
      attrName="xHandle"
      updateAttr={updateBonusDataAttr}
      dataModel={data}
      formModel={{}}
      validations={[Validator.required, Validator.testXHandle]}
      placeholder="@username"
    />
  );
}
